module.exports = __webpack_public_path__ + "img/5e8d6a7.gif";